import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Button, DialogProps } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';

interface DialogBaseProps {
  open: boolean;
  title: string;
  contentText?: string;
  confirmButtonText?: string;
  confirmButtonIcon?: React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
  children?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false; // DialogProps['maxWidth'];
  width?: string | number; // custom CSS width, bv. "600px" of "80%"
  minWidth?: number | string;
}

const DialogBase: React.FC<DialogBaseProps> = ({
  open,
  title,
  contentText,
  confirmButtonText,
  confirmButtonIcon,
  onClose,
  onConfirm,
  children,
  maxWidth='sm',
  width,
  minWidth,
}) => {
  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      // Prevent closing when clicking on the backdrop
      return;
    }
    onClose();
  };

  const hasCustomWidth = Boolean(width);

  return (
    <Dialog 
      className='dialog'
      fullWidth={hasCustomWidth? false : true}      // disable fullWidth when custom width given
      maxWidth={hasCustomWidth ? false : maxWidth}  // maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
      open={open} 
      onClose={handleClose} 
      aria-labelledby="dialog-base-title"
      slotProps={{
        paper: {
          sx: {
            width: {
              xs: '100%',
              sm: '100%',
              md: width || '800px',
            },
            maxWidth: '100%',
            minWidth: {
              xs: '100%',
              md: minWidth || '800px',
            },
          },
        },
      }}
      >
      <DialogTitle id="dialog-base-title" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton aria-label="close" onClick={onClose} size="small">
          <GridCloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {contentText && 
          <DialogContentText
            dangerouslySetInnerHTML={{ __html: contentText }}
          />
        }
        {children && 
          <div>{children}</div>
        } 
      </DialogContent>
      <DialogActions>
        {onConfirm && (
          <Button 
            variant="contained" 
            color="secondary" 
            startIcon={confirmButtonIcon ?? undefined}
            onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DialogBase;
